"use client";
import { useEffect } from "react";
import { createDiagnostics } from "../lib/diagnostics.js";
import { BugReportWidget } from "../components/bug-report/BugReportWidget.js";

declare global { interface Window { __briolinDiag?: ReturnType<typeof createDiagnostics>; } }

export default function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const diag = createDiagnostics(() => performance.now());
    window.__briolinDiag = diag;
    const origError = console.error;
    console.error = (...args: unknown[]) => { diag.record("console", args.map(String).join(" "), "error"); origError(...args); };
    const origFetch = window.fetch;
    window.fetch = async (...args: Parameters<typeof fetch>) => {
      const url = typeof args[0] === "string" ? args[0] : (args[0] as Request).url;
      const res = await origFetch(...args);
      diag.record("network", `${res.status} ${url}`);
      return res;
    };
    if (process.env.NODE_ENV !== "production") {
      import("@axe-core/react").then(({ default: axe }) => import("react-dom").then((ReactDOM) => axe(require("react"), ReactDOM, 1000))).catch(() => {});
    }
    return () => { console.error = origError; window.fetch = origFetch; };
  }, []);
  return <div className="site-shell">{children}<BugReportWidget /></div>;
}
